import { render, staticRenderFns } from "./FolderCosmoformItemHeader.vue?vue&type=template&id=5f60ae16&scoped=true"
import script from "./FolderCosmoformItemHeader.vue?vue&type=script&lang=js"
export * from "./FolderCosmoformItemHeader.vue?vue&type=script&lang=js"
import style0 from "./FolderCosmoformItemHeader.vue?vue&type=style&index=0&id=5f60ae16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60ae16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
